import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { User } from './user.model';

export class AuthData implements Deserializable<JsonObject, AuthData> {
  id?: string;
  token?: string;
  refreshToken?: string;
  dateExpires?: string;
  failedUses?: number;
  user?: User;
  error?: string;

  get userId() {
    return this.user?.id;
  }

  deserialize(input: JsonObject): AuthData {
    if (input == null) {
      return null;
    }

    const userId = input.user?.id || input.userId || '';

    this.id = input.id;
    this.token = input.token;
    this.refreshToken = input.refreshToken;
    this.dateExpires = input.dateExpires;
    this.user = new User().deserialize({ ...{ id: userId }, ...(input.user || {}) });
    this.failedUses = input.failedUses;

    if (input.user?.group?.theme != null) {
      // Copy the Group Theme to the User, once the User object returns the theme, this should be removed
      this.user.group.theme = { ...input.user?.group?.theme };
    }

    return this;
  }

  combine(updatedAuthData: AuthData): AuthData {
    const { userId, ...partialAuthData } = this;
    let user = updatedAuthData?.user;
    if (this.user) {
      user = this.user.combine(updatedAuthData?.user);
    }
    return new AuthData().deserialize({ ...partialAuthData, ...(updatedAuthData || {}), user });
  }
}
